import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_19: FaireProductEntity = {
  token: "legacy_prod_abbott-19",
  type: "product",
  name: 'All Purpose Scissors Black 8" L',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/e1510cc130cbd0733e1b23a416d45512f50516f37ac5738f2932cec0122a6927.jpeg",
  priceDollars: 6,
  msrpDollars: 12,
  subcategory: "Scissors & Tools",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
